
const PortfolioCards = () => {

const appDetails = [
    {
      title: 'Weather App',
      url: 'https://weatherappbc2023.netlify.app/',
      description: 'Weather App written during bootcamp and updated since to add new features.',
      github: 'https://github.com/DataSpot42/weatherapp',
    },
    {
        title: 'To Do App',
        url: 'https://todotodos.netlify.app',
        description: 'To Do app written during bootcamp.',
        github: 'https://github.com/DataSpot42/ReactToDo',
        
      },
      {
        title: 'Card Games App',
        url: 'https://play-card-games.netlify.app',
        description: 'To Do app written during bootcamp.',
        github: 'https://github.com/DataSpot42/card-games-app',
        
      },
      {
        title: 'PunkIPA',
        url: 'https://punkipa.netlify.app',
        description: 'eCommerce App complted during bootcamp with a fellow student. Click on link below to open the app',
        github: 'https://github.com/DataSpot42/punk-local-app',
        
      },
      {
        title: 'DrumKit App',
        url: 'https://camelcode-drumkit.netlify.app',
        description: 'Basic Drum Kit App, created in React after Bootcamp.',
        github: 'https://github.com/DataSpot42/drumkit-app',
        
      },


  ];
    return (appDetails)

}
export default PortfolioCards
  